import { StatusPill } from '@/components/cccd/StatusPill';
import InlineSavingChip from '@/components/ui/badge/InlineSavingChip';
import { btnSecondary } from '@/components/admin/FormComponents';

// headerActions compartido por EventDetailPage y RegionalDetailPage — mismo
// pill + botón + chip de guardado para que ambos encabezados se vean
// idénticos, la única diferencia entre ellos es qué mutación dispara.
export function EventActiveToggle({
  isActive,
  onToggle,
  status,
  isFeaturedInAcademy,
  onToggleFeatured,
  featuredStatus,
  attendeeTicketsEnabled,
  onToggleAttendeeTickets,
  attendeeTicketsStatus,
}: {
  isActive: boolean;
  onToggle: (next: boolean) => void;
  status: 'idle' | 'saving' | 'error';
  // cccd-team-showcase: cuál evento alimenta Competidores en Academy —
  // independiente de isActive (abrir/cerrar inscripciones). Opcional porque
  // no todas las páginas que reusan este header lo necesitan.
  isFeaturedInAcademy?: boolean;
  onToggleFeatured?: (next: boolean) => void;
  featuredStatus?: 'idle' | 'saving' | 'error';
  // cccd-event-attendance-tickets: activa la emisión/visualización de
  // boletos de asistencia — también independiente de isActive.
  attendeeTicketsEnabled?: boolean;
  onToggleAttendeeTickets?: (next: boolean) => void;
  attendeeTicketsStatus?: 'idle' | 'saving' | 'error';
}) {
  return (
    <>
      <StatusPill tone={isActive ? 'success' : 'gray'} label={isActive ? 'Activo' : 'Cerrado'} />
      <button type="button" onClick={() => onToggle(!isActive)} className={`min-h-11 ${btnSecondary}`}>
        {isActive ? 'Cerrar inscripciones' : 'Abrir inscripciones'}
      </button>
      <InlineSavingChip status={status} onRetry={() => onToggle(!isActive)} />

      {onToggleFeatured && (
        <>
          <StatusPill
            tone={isFeaturedInAcademy ? 'success' : 'gray'}
            label={isFeaturedInAcademy ? 'Destacado en Academy' : 'No mostrado en Academy'}
          />
          {!isFeaturedInAcademy && (
            <button
              type="button"
              title="Muestra los equipos y categorías de este evento en Competidores/Documentos de Academy"
              onClick={() => onToggleFeatured(true)}
              className={`min-h-11 ${btnSecondary}`}
            >
              Destacar en Academy
            </button>
          )}
          <InlineSavingChip status={featuredStatus ?? 'idle'} onRetry={() => onToggleFeatured(true)} />
        </>
      )}

      {onToggleAttendeeTickets && (
        <>
          <StatusPill
            tone={attendeeTicketsEnabled ? 'success' : 'gray'}
            label={attendeeTicketsEnabled ? 'Boletos activados' : 'Boletos desactivados'}
          />
          <button
            type="button"
            title="Habilita que los integrantes de equipo vean/descarguen su boleto QR de asistencia"
            onClick={() => onToggleAttendeeTickets(!attendeeTicketsEnabled)}
            className={`min-h-11 ${btnSecondary}`}
          >
            {attendeeTicketsEnabled ? 'Desactivar boletos' : 'Activar boletos'}
          </button>
          <InlineSavingChip
            status={attendeeTicketsStatus ?? 'idle'}
            onRetry={() => onToggleAttendeeTickets(!attendeeTicketsEnabled)}
          />
        </>
      )}
    </>
  );
}
